// extracted by mini-css-extract-plugin
export default {"card":"PolicyCard_card__RB7o9","glow":"PolicyCard_glow__1Lw7Y","icon":"PolicyCard_icon__L3QC4"};